import React from 'react';
import PropTypes from 'prop-types';
import {MultiSelect} from 'react-multi-select-component';
import {useTranslation} from 'react-i18next';

const HighlightCameraSelector = ({options, value, onChange}) => {
  const {t} = useTranslation();
  const selectedCameras = Array.isArray(value) ? value : [];

  return (
    <div className="highlight-camera-selector" style={{color: 'black'}}>
      <MultiSelect
        className="highlight-camera-selector__select"
        options={Array.isArray(options) ? options : []}
        value={selectedCameras}
        onChange={onChange}
        labelledBy="highlight-camera-label"
        overrideStrings={{
          allItemsAreSelected: t('ALL_CAMERAS'),
          search: t('SEARCH'),
          selectAll: t('SELECT_ALL'),
          selectSomeItems: t('CAMERA_SELECT'),
          selectAllFiltered: t('SELECT_ALL')
        }}
        ClearSelectedIcon={null}
      />
      <input
        name="hiddenRequired"
        style={{height: 0, width: 0, opacity: 0}}
        value={selectedCameras.length ? '1' : ''}
        readOnly
        required
      />
    </div>
  );
};

HighlightCameraSelector.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
  })),
  value: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func.isRequired
};

HighlightCameraSelector.defaultProps = {
  options: [],
  value: []
};

export default HighlightCameraSelector;
